import React from 'react';
import {SidebarContent} from '../SidebarContent';
import './CoordinatesSidebar.scss';
import {mcCopy, mcEditPointCoordinates} from '@mc/react-ui-icons';
import {Card, Col, Row, Space, Title, Text, toaster} from '@mc/ui-v4';
import {ToolbarButton} from '../../toolbar/ToolbarButton';

export type CoordinatesProps = {
    jtsk: number[];
    gps: number[];
};

type Props = {onClose: () => void; coordinateLocation?: CoordinatesProps};

export const CoordinatesSidebar: React.FC<Props> = ({onClose, coordinateLocation}) => {
    const {gps, jtsk} = coordinateLocation;

    const roundLocation = (value: number) => {
        return Math.round(value * 100000) / 100000;
    };
    const roundJtskLocation = (value: number) => {
        return Math.round(value * 100) / 100;
    };

    const copyToClipboard = (text: string) => {
        if (!navigator.clipboard) {
            //Tato chyba se děje pokud jedeme na stránce, která není localhost a není https
            toaster.warning('Aplikace nemá povolený přístup ke schránce');
        } else {
            navigator.clipboard.writeText(text);
        }
    };

    return (
        <SidebarContent title={'Souřadnice bodu'} icon={mcEditPointCoordinates} onClose={onClose} wrapContent className={'fit-content'}>
            <Space vertical className={'mb-1'}>
                <Card
                    className={'sidepanel-card mx-1'}
                    mode={'view'}
                    title={
                        <Row noGutters>
                            <Col className={'my-auto pl-1'}>
                                <Title type={'block'}>GPS</Title>
                            </Col>
                        </Row>
                    }
                    extra={
                        <div className={'d-flex'}>
                            <Text className={'my-auto'} type={'listItem'}>{`${roundLocation(gps[1])}`}</Text>
                            <Text className={'my-auto'} type={'listItem'} intent={'secondary'}>{`N,`}</Text>
                            <Text className={'my-auto'} type={'listItem'}>{`${roundLocation(gps[0])}`}</Text>
                            <Text className={'my-auto'} type={'listItem'} intent={'secondary'}>{`E`}</Text>
                            <ToolbarButton icon={mcCopy} title={'Zkopírovat do schránky'} onClick={() => copyToClipboard(`${gps[1]}N, ${gps[0]}E`)} />
                        </div>
                    }
                />
                <Card
                    className={'sidepanel-card mx-1'}
                    mode={'view'}
                    title={
                        <Row noGutters>
                            <Col className={'my-auto pl-1'}>
                                <Title type={'block'}>S-JTSK</Title>
                            </Col>
                        </Row>
                    }
                    extra={
                        <div className={'d-flex ml-2'}>
                            <Text className={'my-auto'} type={'listItem'} intent={'secondary'}>{`Y: `}</Text>
                            <Text className={'my-auto'} type={'listItem'}>{`${roundJtskLocation(jtsk[0])}`}</Text>
                            <Text className={'my-auto'} type={'listItem'} intent={'secondary'}>{`, X: `}</Text>
                            <Text className={'my-auto'} type={'listItem'}>{`${roundJtskLocation(jtsk[1])}`}</Text>
                            <ToolbarButton
                                classname={'ml-1'}
                                icon={mcCopy}
                                title={'Zkopírovat do schránky'}
                                onClick={() => copyToClipboard(`Y: ${jtsk[0]}, X: ${jtsk[1]}`)}
                            />
                        </div>
                    }
                />
            </Space>
        </SidebarContent>
    );
};
